import React from "react";

export const StatCard: React.FC<{
  value: string;
  label: string;
}> = ({ value, label }) => (
  <div className="text-center border-r border-border last:border-r-0 py-4">
    <div className="text-3xl md:text-4xl font-display font-bold tracking-tight text-text-primary tabular-nums">
      {value}
    </div>
    <div className="mt-1.5 text-[10px] font-mono uppercase tracking-[0.16em] text-text-muted">
      {label}
    </div>
  </div>
);
